import { Component, EventEmitter, OnInit, ViewChild, Output } from '@angular/core';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { chofer } from 'src/app/shared/object/chofer.model';
import { chofer_sucursal } from 'src/app/shared/object/chofer_sucursal.model';
import { chofer_sucursalJoin } from 'src/app/shared/object/chofer_sucursalJoin.model'
import { FuncionesService } from '../../../shared/validadores/funciones.service';
import { SecurityService } from '../../../shared/services/security.service';
import { ValidadoresService } from '../../../shared/validadores/validadores';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { ChoferSucursalService } from 'src/app/services/chofer-sucursal.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutService } from "src/app/shared/services/rut.service";


@Component({
  selector: 'app-chofer',
  templateUrl: './chofer.component.html',
  styleUrls: ['./chofer.component.scss'],
  providers: [SecurityService, ValidadoresService]

})
export class ChoferComponent implements OnInit {
  private client: GraphQLClient = null;
  choferesList: Array<any> = null;
  selectedchofer: chofer_sucursalJoin;
  chofer: chofer_sucursalJoin;

  public formAgregarChofer_Sucursal: FormGroup;
  public formEditarChofer_Sucursal: FormGroup;

  public rut_empresa;
  public sucursal_codigo;

  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  public codgo_modulo: number = 14;
  public busquedaEstado

  public nombreBusquedaCG: string
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

  public processingAgregar: boolean = false;
  public processingEditar: boolean = false;

  constructor(
    client: GraphQLClient,
    private funcservice: FuncionesService,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private choferSucursalService: ChoferSucursalService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private rutService: RutService,
  ) {
    this.client = client;
    this.formAgregarChofer_Sucursal = this.construyeFormAgrega();
    this.formEditarChofer_Sucursal = this.construyeFormEdita();
  }

  agregar() {
    this.selectedchofer = {
      rut: null,
      nombre: '',
      estado: null,
      fono1: '',
      fono2: '',
      fecha_asignacion: null,
      fecha_creacion: null,
      rut_empresa: null,
      sucursal_codigo: null,
      es_cliente: null,
      rut_antiguo: null,
    };
    this.formAgregarChofer_Sucursal.reset();
    this.processingAgregar = false;
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }

  cambiaEstado(chofer_seleccionado: chofer_sucursalJoin) {
    chofer_seleccionado.rut_empresa = (Number(this.rut_empresa))
    chofer_seleccionado.sucursal_codigo = (Number(this.sucursal_codigo))
    if (chofer_seleccionado.estado) {
      chofer_seleccionado.estado = false;
    }
    else {
      chofer_seleccionado.estado = true;
    }
    this.editaChofer(chofer_seleccionado);
  }
  construyeFormAgrega() {
    return new FormGroup
      ({
        rut: new FormControl('', [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]),
        nombre: new FormControl('', [Validators.maxLength(100), Validators.required]),
        fono1: new FormControl('', [Validators.maxLength(30)]),
        fono2: new FormControl('', [Validators.maxLength(30)]),
        estado: new FormControl(true),
        es_cliente: new FormControl(false),
        rut_antiguo: new FormControl(''),
      });
  }

  construyeFormEdita() {
    return new FormGroup
      ({
        rut_empresa: new FormControl(''),
        sucursal_codigo: new FormControl(''),
        rut: new FormControl({ value: '', disabled: true }, [Validators.maxLength(13), Validators.required]),
        nombre: new FormControl('', [Validators.maxLength(100), Validators.required]),
        fono1: new FormControl('', [Validators.maxLength(30)]),
        fono2: new FormControl('', [Validators.maxLength(30)]),
        estado: new FormControl(true),
        es_cliente: new FormControl(false),
        rut_antiguo: new FormControl(''),
      });
  }

  ngOnInit() {
    this.selectedchofer = {
      rut: null,
      nombre: '',
      fecha_creacion: null,
      fono1: null,
      fono2: null,
      estado: null,
      rut_empresa: null,
      sucursal_codigo: null,
      fecha_asignacion: null,
      es_cliente: null,
      rut_antiguo: null
    };
    this.busquedaEstado = 3
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();


    this.obtenerDatosChofer();

  }

  buscar() {
    this.obtenerDatosChofer();
  }

  obtenerDatosChofer() {
    const inputParams = {
      entidad: {
        tipobusqueda: this.busquedaEstado,
        rut_empresa: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        nombre: this.nombreBusquedaCG ? this.nombreBusquedaCG.trim() : ""
      }
    }
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
        query ($entidad: chofer_sucursalJoinInputType) {
          chofer_sucursal {
            obtenerchoferSucursalxRutEmpresaSucursal(entidad: $entidad, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              respuesta {
                registros {
                  rut
                  nombre
                  estado
                  fecha_creacion
                  fono1
                  fono2
                  es_cliente
                  rut_antiguo
                }
              }
            }
          }
        }
        `,
        fetchPolicy: 'network-only',
        variables: inputParams,
      },
      function (respuesta) {
        self.choferesList =
          respuesta.data.chofer_sucursal.obtenerchoferSucursalxRutEmpresaSucursal.respuesta.registros;
        self.choferesList.forEach((mov, index) => {
          mov.rutFormato = self.rutService.AgregarDV(mov.rut)
        })
      }
    );
  }

  get frmAgregaRut() { return this.formAgregarChofer_Sucursal.get('rut'); }
  get frmAgregaNombre() { return this.formAgregarChofer_Sucursal.get('nombre'); }
  get frmAgregaFono1() { return this.formAgregarChofer_Sucursal.get('fono1'); }
  get frmAgregaFono2() { return this.formAgregarChofer_Sucursal.get('fono2'); }
  get frmAgregaEstado() { return this.formAgregarChofer_Sucursal.get('estado'); }
  get frmAgregaEs_cliente() { return this.formAgregarChofer_Sucursal.get('es_cliente'); }

  get frmEditaRut() { return this.formEditarChofer_Sucursal.get('rut'); }
  get frmEditaRutAntiguo() { return this.formEditarChofer_Sucursal.get('rut_antiguo'); }
  get frmEditaNombre() { return this.formEditarChofer_Sucursal.get('nombre'); }
  get frmEditaFono1() { return this.formEditarChofer_Sucursal.get('fono1'); }
  get frmEditaFono2() { return this.formEditarChofer_Sucursal.get('fono2'); }
  get frmEditaEstado() { return this.formEditarChofer_Sucursal.get('estado'); }
  get frmEditaRut_Empresa() { return this.formEditarChofer_Sucursal.get('rut_empresa'); }
  get frmEditaSucursal_codigo() { return this.formEditarChofer_Sucursal.get('sucursal_codigo'); }
  get frmEditaEs_cliente() { return this.formEditarChofer_Sucursal.get('es_cliente'); }

  ValidaQueExisteDatosChofer() {
    // Validar que el formulario sea válido
    if (!this.formAgregarChofer_Sucursal.valid) {
      this.toastrService.warning('Por favor complete todos los campos requeridos correctamente');
      return;
    }

    if (this.processingAgregar) return;

    this.processingAgregar = true;
    let self = this; // this is unused
    var datachofer: chofer_sucursalJoin = new chofer_sucursalJoin();

    datachofer.rut = Number(this.validadores._desenmascaraRutyQuitaDV(this.frmAgregaRut.value));
    datachofer.rut_empresa = Number(this.rut_empresa);
    datachofer.sucursal_codigo = Number(this.sucursal_codigo);
    this.client.query(
      {
        query: gql`
          query ($entidad: chofer_sucursalJoinInputType) {
            chofer_sucursal {
              existechoferSucursalJoin(entidad: $entidad) {
                respuesta
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          entidad: datachofer
        },
      },
      function (respuesta) {

        if (respuesta.data.chofer_sucursal.existechoferSucursalJoin.respuesta) {
          const res = window.confirm('El chofer ingresado ya existe. ¿Desea sobreescribirlo?');
          if (res)
            self.insertar();
          else
            self.processingAgregar = false;
        }
        else {
          self.insertar();
        }
      }
    );
  }

  insertar() {
    this.chofer = {
      rut: Number(this.validadores._desenmascaraRutyQuitaDV(this.frmAgregaRut.value)),
      nombre: this.frmAgregaNombre.value,
      fono1: this.frmAgregaFono1.value,
      fono2: this.frmAgregaFono2.value,
      estado: this.frmAgregaEstado.value,
      fecha_asignacion: null,
      fecha_creacion: null,
      rut_empresa: this.rut_empresa,
      sucursal_codigo: this.sucursal_codigo,
      es_cliente: this.frmAgregaEs_cliente.value,
      rut_antiguo: this.frmAgregaRut.value,
    }
    let flag: boolean = true;
    this.agregarChofer(this.chofer);
  }

  agregarChofer(chofer_ingresado: chofer_sucursalJoin) {
    const inputParams: any = {
      entidad: chofer_ingresado
    }

    this.choferSucursalService.agregarEditarChoferSucursal(inputParams, ({ mensajes, respuesta }) => {
      this.processingAgregar = false;
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hideAgregar()
      setTimeout(() => this.obtenerDatosChofer(), 1000);
    })
  }

  showForEdit(cho: chofer_sucursalJoin) {
    this.formEditarChofer_Sucursal.reset();
    this.selectedchofer = Object.assign({}, cho);

    this.frmEditaRut.setValue(this.validadores._enmascaraRut(String(cho.rut)));
    this.frmEditaRutAntiguo.setValue(cho.rut_antiguo);

    this.frmEditaNombre.setValue(cho.nombre);
    this.frmEditaFono1.setValue(cho.fono1);
    this.frmEditaFono2.setValue(cho.fono2);
    this.frmEditaEstado.setValue(cho.estado);
    this.frmEditaEs_cliente.setValue(cho.es_cliente);
    this.processingEditar = false;
  }


  actualizar() {
    // Validar que el formulario sea válido
    if (!this.formEditarChofer_Sucursal.valid) {
      this.toastrService.warning('Por favor complete todos los campos requeridos correctamente');
      return;
    }

    if (this.processingEditar) return;

    this.processingEditar = true;
    this.chofer = {
      rut: Number(this.validadores._desenmascaraRutyQuitaDV(this.frmEditaRut.value)),
      nombre: this.frmEditaNombre.value,
      fono1: this.frmEditaFono1.value,
      fono2: this.frmEditaFono2.value,
      estado: this.frmEditaEstado.value,
      rut_empresa: this.rut_empresa,
      sucursal_codigo: this.sucursal_codigo,
      fecha_creacion: null,
      fecha_asignacion: null,
      es_cliente: this.frmEditaEs_cliente.value,
      rut_antiguo: this.frmEditaRutAntiguo.value
    };
    this.editaChofer(this.chofer);
  }

  editaChofer(chofer_seleccionado: chofer_sucursalJoin) {
    delete chofer_seleccionado['__typename'];
    const inputParams: any = {
      entidad: chofer_seleccionado
    }

    this.choferSucursalService.agregarEditarChoferSucursal(inputParams, ({ mensajes, respuesta }) => {
      this.processingEditar = false;
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hideEditar()
      setTimeout(() => this.obtenerDatosChofer(), 1000);
    })
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        rut_usu: self.rut_usuario,
        codgo_modulo: self.codgo_modulo,
        cod_operacion: codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        rut_usu: self.rut_usuario,
        codgo_modulo: self.codgo_modulo,
        cod_operacion: codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  permitirCambioEstado(chofer_seleccionado: chofer_sucursalJoin) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        rut_usu: self.rut_usuario,
        codgo_modulo: self.codgo_modulo,
        cod_operacion: codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(chofer_seleccionado);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  hideAgregar() {
    this.agregarModal.hide()
  }

  hideEditar() {
    this.editarModal.hide()
  }
}




